export const UPPERCASE_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const LOWERCASE_LETTERS = 'abcdefghijklmnopqrstuvwxyz';
export const SPECIAL_CHARACTERS = '!@#$%^&*()_+-=[]{}|;:,.<>?';
export const DIGITS = '0123456789';
export const ERROR_TYPES = {
    ACCESS_CLOSED: 'ACCESS_CLOSED',
};
